if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      // limit: boostPFSConfig.custom.products_per_row == 4 ? boostPFSConfig.custom.products_per_page : boostPFSConfig.custom.products_per_page - 1,
      limit: 24,
      loadProductFirst: false,
      numberFilterTree: 2,
      selectOptionContainer: '.grid__item .card-wrapper',
      stickyFixTopPos: true,
      // Filter Mobile
      filterTreeMobileStyle: 'style3-fullwidth', // 'style1', style2', 'style2-fullwidth','style3', 'style3-fullwidth'
    },
    selector: {
      otpTopCartCount: '.cart-count-bubble'
    }
  };
}

(function () {
  var onSale = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


  BoostPFS.inject(this);
  /* For Filter Setting Layout */
  Selector.stickyElementDesktop = jQ('.boost-pfs-filter-left-col').length > 0 && !Utils.isMobile() ? '.boost-pfs-filter-left-col' : '.boost-pfs-filter-tree';
  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data,index) {
    if (!data) data = this.data;
    if (!index) index = this.index;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);
    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
    var saleClass = onSale ? boostPFSTemplate.saleClass : '';
    var gridIndex = this.index;
    var ratioImage = getRatioImage(data);
    var imageAspectRatio = ratioImage / getAspectRatio(data.images_info[0]) * 100;
    var autifySoldOutClass = data.available ? '' : 'sold-out';

    itemHtml = itemHtml.replace(/{{autifySoldOutClass}}/g, autifySoldOutClass);

    itemHtml = itemHtml.replace(/{{imageAspectRatio}}/g, imageAspectRatio);
      
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);


    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add Card product class
    itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass(data));
    // Add Card inner product class
    itemHtml = itemHtml.replace(/{{cardInnerProductClass}}/g, buildCardInnerProductClass(data));
    // Add Card badge position
    itemHtml = itemHtml.replace(/{{cardBadgePosition}}/g, boostPFSThemeConfig.custom.badge_position);
    // Add check card heading five
    itemHtml = itemHtml.replace(/{{cardIsHeadingFive}}/g, buildCardIsHeadingFive(data));
    // Add sold out Label
    itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
    // Add sale Label
    itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
    // Add Novuna Finance
    itemHtml = itemHtml.replace(/{{novunaFinance}}/g, buildNovuna(data));
    itemHtml = itemHtml.replace(/{{itemIndex}}/g, gridIndex);
    

    // Add Review
    if (typeof Integration === 'undefined' ||
      (typeof Integration != 'undefined' &&
        typeof Integration.hascompileTemplate == 'function' &&
        !Integration.hascompileTemplate('reviews'))) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
    }

    // Add Description
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, boostPFSThemeConfig.custom.description || '');

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // Add pre-owned-watches
    var preownedWatchesHtml = '';
    var preownedWatchesPriceHtml = '';
    for (var col of data.collections) {
     
       if (col.handle == "pre-owned-watches") {
          if (Utils.getProductMetafield(data, 'custom', 'watch_product_label') && Utils.getProductMetafield(data, 'custom', 'watch_product_label') !== '') {
            preownedWatchesHtml += '<div class="watch_product_div">' +
                '<span class="watch_product_spn">' + Utils.getProductMetafield(data, 'custom', 'watch_product_label') + '</span>' +
            '</div>';
          }

          if (Utils.getProductMetafield(data, 'custom', 'from_price') && Utils.getProductMetafield(data, 'custom', 'from_price') !== '') {
            preownedWatchesPriceHtml += `<div class="from_price_div">
                <span class="custom_prc_spn">${Utils.getProductMetafield(data, 'custom', 'from_price')}</span>
            </div>`;
          }

          var properties =  Utils.getProductMetafield(data, 'custom', 'properties')
            if (properties) {
              var newProperties = properties.split(",");
              for (var prop of newProperties) {
              preownedWatchesPriceHtml += `<span class="custom_prop">${prop}&nbsp;  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 12 9" fill="none">
                                          <path d="M11.5 1L4.5 8L1 4.5" stroke="#554E5C" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg></span>`;
            }
          }
      
          /*if (Utils.getProductMetafield(data, 'custom', 'reference_number') && Utils.getProductMetafield(data, 'custom', 'reference_number')!== '') {
            preownedWatchesPriceHtml += `<div class="ref_num_div">
                <span class="ref_spn_spn">Ref:${Utils.getProductMetafield(data, 'custom', 'reference_number')}</span>
            </div>`;
            }*/
             
          
       }
    }
    itemHtml = itemHtml.replace(/{{itemPreownedWatches}}/g, preownedWatchesHtml);
    itemHtml = itemHtml.replace(/{{itemPreownedWatchesPrice}}/g, preownedWatchesPriceHtml);

    /* Start-Boost-201500 */
    var itemCustomHtml = '';
    var itemBadgeHtml = '';
    var itemHiddenBadgeHtml = '';


    var box_yes = data.tags.includes('attr:_pow-box_yes') ? true : false;
    var papers_yes = data.tags.includes('attr:_pow-papers_yes') ? true : false
      
    var watch_year = data.tags.includes('attr:_pow-year_')
    var watches_title = data.title.toLowerCase();
    var watches_vendor = data.vendor.toLowerCase();
    const watch_condition = ["Audemars", "Piguet", "Breitling", "Cartier", "Omega", "Patek Philippe", "Rolex", "TAG Heuer", "Tudor", "Watch", "Bulgari", "Carl F.", "Audemars Piguet"]

    // console.log(!watches_title.includes("necklace"))
    const watch_check = watch_condition.some(el => watches_title.includes(el.toLowerCase()));
    const watch_check2 = watch_condition.some(el => watches_vendor.includes(el.toLowerCase()));
    const watch_check_tag = data.tags.some(x => x.includes("attr:_watch-"));

    var new_yes = data.tags.includes('attr:_tag_new_in') ? true : false;
    var potm_yes = data.tags.includes('attr:_tag_POTM') ? true : false;
    var editors_yes = data.tags.includes('attr:_tag_Editors-pick') ? true : false;

  if (new_yes) {
      itemBadgeHtml += '<div class="badge badge-new">' +
                                '<p>New in</p>' +
                        '</div>';
      }

     if (data.skus.length > 0) {
        for (let sku of data.skus) {
            if (sku.includes(('S2-006'))) {
                   itemBadgeHtml += '<div class="badge badge-valution">' +
                                '<p>Comes With Valuation</p>' +
                        '</div>';
            }
        }
      }

      if (editors_yes) {
      itemBadgeHtml += '<div class="badge badge-editors">' +
                                '<p>Editors Pick</p>' +
                        '</div>';
      }

     if (potm_yes) {
      itemBadgeHtml += '<div class="badge badge-potm">' +
                                '<p>Product of the Month</p>' +
                        '</div>';
      }

    // Test product https://admin.shopify.com/store/autify-charles-fish-demo/products/8469452423403
    
    var year = '';
    for (let tag of data.tags) {
      if (tag.includes(('attr:_pow-year_'))) {
        year = tag.slice(tag.length - 4, tag.length);
        break;
      }
    }

   
  
    if (box_yes) {
      itemCustomHtml += '<div class="feature-item order-3">' +
                            '<div class="feature-item__inner">' +
                                '<p>Box <i class="fa-solid fa-check"></i></p>' +
                            '</div>' +
                        '</div>';
    }
    if (papers_yes) {
      itemCustomHtml += '<div class="feature-item order-2">' +
                            '<div class="feature-item__inner">' +
                                '<p>Papers <i class="fa-solid fa-check"></i></p>' +
                            '</div>' +
                        '</div>';
    }
   // if(watch_check_tag && !watches_title.includes("necklace")){
   //   itemCustomHtml += '<div class="feature-item order-2">' +
   //                        '<div class="feature-item__inner"> ' +
   //                            '<p>Year: ' + watch_year '<i class="fa-solid fa-check"></i></p>' +
   //                        '</div>' +
   //                    '</div>';
   // }

     if (year) {
      year = year.replace(/attr:_pow-model-number_/g, '');
       // itemCustomHtml += '<div class="ref_num_div"><span class="ref_spn_spn">Year: ' + year + '</span></div>';
       itemCustomHtml += '<div class="feature-item order-2">' +
                           '<div class="feature-item__inner"> ' +
                               '<p>Year: ' + year + '<i class="fa-solid fa-check"></i></p>' +
                           '</div>' +
                       '</div>';
    }
      

     
    var propertiesMeta = Utils.getProductMetafield(data, 'custom', 'properties');
    if (propertiesMeta !== null) {
      var splitMeta = propertiesMeta.split(',');
      for (var i = 0; i < splitMeta.length; i++) {
        itemCustomHtml += '<span class="prop">' + splitMeta[i] + '&nbsp;  ' +
                            '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 12 9" fill="none">' +
                              '<path d="M11.5 1L4.5 8L1 4.5" stroke="#554E5C" stroke-linecap="round" stroke-linejoin="round"/>' +
                            '</svg>' +
                          '</span>';
      }
    }
    // Start Boost Custom #206852
    var refTag = '';
    for (let tag of data.tags) {
      if (tag.includes(('attr:_pow-model-number_'))) {
        refTag = tag;
        break;
      }
    }
    
    if (refTag) {
      refTag = refTag.replace(/attr:_pow-model-number_/g, '');
       itemCustomHtml += '<div class="ref_num_div"><span class="ref_spn_spn">Ref ' + refTag + '</span></div>';
    }
    itemHtml = itemHtml.replace(/{{itemCustom}}/g, itemCustomHtml);
    itemHtml = itemHtml.replace(/{{itemBadges}}/g, itemBadgeHtml);
    itemHtml = itemHtml.replace(/{{itemHiddenBadges}}/g, itemHiddenBadgeHtml);

    
    // Start Boost Custom #206852
    /* End-Boost-201500 */
    
    // Add main attribute (Always put at the end of this function)
    /* Swym integration */
    var itemWishlistHtml = '<button data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product wishlist swym-button product_' + data.id + '" data-swaction="addToWishlist" data-product-id="' + JSON.stringify(data.id) + '" data-variant-id="' + data.variants[0].id + '" data-product-url="' + boostPFSConfig.shop.url + Utils.buildProductItemUrl(data, false) + '"></button>';
    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
    if(Globals.queryParams.collection_scope == "412356083947" && index == 3){
      return itemHtml+customBanner;
    }

    if (data.skus.length > 0) {
        for (let sku of data.skus) {
            if (sku.includes(('S4'))) {
                var web_title = '';
                for (let tag of data.tags) {
                    if (tag.includes(('attr:_pow-web-tittle_'))) {
                        web_title = tag.slice(21);
                        var web_title_1 = web_title.replace(/-/g, " ");
        
                        itemHtml = itemHtml.replace(/{{itemTitle}}/g, web_title_1);
                    };
        
                    var s4_brand = '';
                    if (tag.includes(('attr:_pow-brand_'))) {
                        s4_brand = tag.slice(16);
                        var s4_brand_1 = s4_brand.replace(/-/g, " ");
                        itemHtml = itemHtml.replace(/{{itemBrand}}/g, s4_brand_1);
                    }
                }
                break;
            } else {
                itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
                itemHtml = itemHtml.replace(/{{itemBrand}}/g, " ");
            }
        }
    } else {
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{itemBrand}}/g, " ");
    }

    console.log("Globals", Globals);

    const colId = Globals.queryParams.collection_scope;

    if (colId == "415917048043" || colId == "415916523755" || colId == "415821234411" || colId == "415916654827" || colId == "415916556523" || colId == "415888310507" || colId == "415888343275" || colId == "415888376043" || colId == "416051331307" || colId == "415820775659" || colId == "413451747563" || colId == "415888408811" || colId == "415888441579" || colId == "415888474347" || colId == "415917572331" || colId == "415820677355" || colId == "415821299947" || colId == "415820939499" || colId == "431036170475" || colId == "415917048043" || colId == "415888507115" || colId == "415820710123" || colId == "415916490987" || colId == "415821168875" || colId == "415820808427" || colId == "415820841195" || colId == "415820873963" || colId == "415820972267" || colId == "415821136107" || colId == "415821005035" || colId == "415821037803" || colId == "415821103339" || colId == "415820906731" || colId == "431036039403" || colId == "415821070571" || colId == "415916687595" || colId == "415916589291" || colId == "415821496555"){
      var bannerHtml = '<li class="grid__item grid_big-item">' + 
      '<div class="image--area">' +
        '<img src="https://cdn.shopify.com/s/files/1/0662/2635/6459/files/rolex2_a76b2891-a0ad-45ab-83b2-0d3d889653bd.jpg?v=1721309978"></img>' +
      '</div>' +
      '<div class="content--area">' +
        '<p class="h5"> 0% APR finance available </p>' +
        '<p> 0% interest is available on all our new branded jewellery and watches and our pre-owned watches range.  </p>' +
        '<a href="https://charlesfish.co.uk/pages/finance-information-1"> Find out more </a>' +
      '</div>' +
    '</li>';

       var bannerHtmlSecond = '<li class="grid__item grid_big-item">' + 
        '<div class="image--area">' +
          '<img src="https://cdn.shopify.com/s/files/1/0662/2635/6459/files/MAcro_3.jpg?v=1721309981"></img>' +
        '</div>' +
        '<div class="content--area">' +
          '<p class="h5">Cant find what you are looking for?</p>' +
          '<p> Let us know what you’re looking for and we will do all the hard work and find it for you.  </p>' +
          '<a href="https://charlesfish.co.uk/pages/source-a-watch">Source a watch</a>' +
        '</div>' +
      '</li>';
    } 
    else if (Globals.queryParams.collection_scope == "415819464939" || Globals.queryParams.collection_scope == "433093148907") {
       var bannerHtml = '<li class="grid__item grid_big-item">' + 
      '<div class="image--area">' +
        '<img src="https://cdn.shopify.com/s/files/1/0662/2635/6459/files/30.05.24_MODEL_SWAMI_0709-2.jpg?v=1721313569"></img>' +
      '</div>' +
      '<div class="content--area">' +
        '<p class="h5"> Independently valued and authenticated </p>' +
        '<p> Every item in this collection comes with an independent valuation and a certificate of authenticity from The Assay Office.   </p>' +        
      '</div>' +
    '</li>';

       var bannerHtmlSecond = '<li class="grid__item grid_big-item">' + 
        '<div class="image--area">' +
          '<img src="https://cdn.shopify.com/s/files/1/0662/2635/6459/files/12.03.24_POJ_CHRISTINA_77164102-61-2.jpg?v=1721312804"></img>' +
        '</div>' +
        '<div class="content--area">' +        
          '<p class="h5"> Fast shipping and easy returns </p>' +  
          '<p> Order by 2 PM Monday to Friday and we will dispatch your items on the same day. Shipping is free on all orders over £49. </p>' +
          '<p>Returns are free for UK customers requiring an exchange or refund. </p>' +
          '<a href="https://charlesfish.co.uk/pages/delivery-information">Find Out More</a>' +
        '</div>' +
      '</li>';
    } else if (colId == "415820382443" || colId == "415820415211" || colId == "415820349675" || colId == "433093148907" || colId == "415819661547" || colId == "429683540203" || colId == "431165898987" || colId == "431125233899" || colId == "431166062827" || colId == "431166128363" || colId == "415820120299" || colId == "415819858155" || colId == "415819890923" || colId == "415820185835" || colId == "415819923691" || colId == "415819956459" || colId == "415820251371" || colId == "415820284139" || colId == "415819989227" || colId == "413451714795" || colId == "415819792619" || colId == "415819694315" || colId == "415819759851" || colId == "415820054763 " || colId == "415873007851" || colId == "415820021995" || colId == "415873106155" || colId == "415820447979"){
      var bannerHtml = '<li class="grid__item grid_big-item">' + 
      '<div class="image--area">' +
        '<img src="https://cdn.shopify.com/s/files/1/0662/2635/6459/files/30.05.24_MODEL_SWAMI_0709-2.jpg?v=1721313569"></img>' +
      '</div>' +
      '<div class="content--area">' +
        '<p class="h5"> Fast shipping and easy returns </p>' +
        '<p> Order by 2 PM Monday to Friday and we will dispatch your items on the same day. Shipping is free on all orders over £49. </p>' +        
        '<p>Returns are free for UK customers requiring an exchange or refund. </p>' +
        '<a href="https://charlesfish.co.uk/pages/delivery-information">Find Out More</a>' +
      '</div>' +
    '</li>';

       var bannerHtmlSecond = '<li class="grid__item grid_big-item">' + 
        '<div class="image--area">' +
          '<img src="https://cdn.shopify.com/s/files/1/0662/2635/6459/files/12.03.24_POJ_CHRISTINA_77164102-61-2.jpg?v=1721312804"></img>' +
        '</div>' +
        '<div class="content--area">' +
          '<p class="h5">Enjoy up to £100 off Your First Purchase</p>' +
          '<p> Sign up to our newsletter to get your welcome discount code straight away and start shopping. Plus get latest offers and early VIP access to our weekly new pieces!  </p>' +
          '<a href="https://latest.charlesfish.co.uk/p/7PU0-3PO/newslettersignup">Subscribe Now</a>' +
        '</div>' +
      '</li>';
    } 
    else {
      var bannerHtml = '';
      var bannerHtmlSecond = '';
    }

    if(window.innerWidth > 768) {
        if (index == 6) {
          itemHtml += bannerHtml;
      }
      if (index == 12) {
        itemHtml += bannerHtmlSecond;
      }
  
    } else {
      if (index == 5) {
        itemHtml += bannerHtml;
      }
      if (index == 11) {
        itemHtml += bannerHtmlSecond;
      }
  
    }

    
    return itemHtml;
  };


  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildImages(data) {
    var html = '';
    if (images && Array.isArray(images) && images.length > 0) {
      html +=   `<div class="card__media">`;
      var aspectRatio = '',
        rangeWidths = boostPFSRangeWidths;

      var dataSrcSet = '',
        imgAlt = data.title,
        flipImageSrcSet = '';

      var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
        boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
        boostPFSThemeConfig.custom.show_secondary_image == true;

      for (var i = 0; i < rangeWidths.length; i++) {
        dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';

        if (activeSwapImage) {
          flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
        }

        if (i < rangeWidths.length - 1) {
          dataSrcSet += ', ';

          if (activeSwapImage) {
            flipImageSrcSet += ', ';
          }
        }
      }

      aspectRatio = images[0]['width'] / images[0]['height'];
      html += '<div class="media media--transparent media--hover-effect"><img class="motion-reduce"' +
        'loading="lazy"' +
        'srcset="' + dataSrcSet + '" ' +
        'height="' + images[0].height + '" ' +
        'width="' + images[0].width + '" ' +
        'sizes="(min-width: 1100px) 535px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"' +
        'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
        'alt="' + imgAlt + '" />';

      if (activeSwapImage) {
        html += '<img class="motion-reduce"' +
        'loading="lazy"' +
        'srcset="' + flipImageSrcSet + '" ' +
        'height="' + images[1].height + '" ' +
        'width="' + images[1].width + '" ' +
        'sizes="(min-width: 1100px) 535px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"' +
        'src="' + Utils.optimizeImage(images[1].src, '533x') + '" ' +
        'alt="' + imgAlt + '" />';
      }
      html += '</div>';
      html += '</div>';
    } else {
      html += `<div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading">
                    <a href="#" class="full-unstyled-link">
                      ${data.title}
                    </a>
                  </h3>
                </div>
              </div>`;
    }
    return html;
  }

  function buildCardProductClass(data) {
    var html = '' + boostPFSThemeConfig.custom.card_style;
    if (!images) {
      html += ' card--text';
    } else {
      html += ' card--media';
    }
    if (boostPFSThemeConfig.custom.card_style == 'card') {
      html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (!images && boostPFSThemeConfig.custom.card_style == 'card') {
      html += ' ratio';
    }
    return html;
  }

  function buildCardInnerProductClass(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.card_style == 'standard') {
      html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
      html += ' ratio';
    }
    return html;
  }

  function buildCardIsHeadingFive(data) {
    var html = '';
    if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
      html = 'p';
    }
    return html;
  }

  function buildVendor(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
      boostPFSThemeConfig.custom.show_vendor === true) {
      html = boostPFSTemplate.vendorHtml;
    }
    return html;
  }

  function buildPrice(data) {
    var html = '';
    var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
    var priceAmount = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.price_min, 'money_with_currency') : Utils.formatMoney(data.price_min);
    var compareAtPrice = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.compare_at_price_min, 'money_with_currency') : Utils.formatMoney(data.compare_at_price_min);
    var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount) : priceAmount;
    var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''
    html = `<div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''}">
          <div class="price__container">
            <div class="price__regular">
              <span class="product_regular_price visually-hidden visually-hidden--inline">
                ${boostPFSConfig.label.regular_price}
              </span>
              <span class="price-item price-item--regular">
                ${onSale ? compareAtPrice : moneyPrice}
              </span>
            </div>
            <div class="price__sale">
              <span class="visually-hidden visually-hidden--inline">
                ${boostPFSConfig.label.regular_price}
              </span>
              <span>
             
              </span>
              <span class="visually-hidden visually-hidden--inline">${boostPFSConfig.label.sale_price}</span>
              <span class="price-item price-item--sale price-item--last">
                ${moneyPrice}
              </span>
            </div>
            <small class="unit-price caption ${unitPriceClass}">
              <span class="visually-hidden">${boostPFSConfig.label.unit_price}</span>
              <span class="price-item price-item--last">
                <span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
                <span aria-hidden="true">/</span>
                <span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
              </span>
            </small>
          </div>
        </div>`
    return html;
  }

    var testTag = '';
  // for (let tag of data.tags) {
  //   if (tag.includes(('finance_'))) {
  //     testTag = tag;
  //     break;
  //   }
  // }

  var newTag = '';
  var finalMonth = '12';
  function buildNovuna(data) {
    var minOrderAmount = 2000;
    var maxOrderAmount = 30000;
    var minDepositPercent = 0.10;
    var financePrice = data.price_min;

    if(financePrice < minOrderAmount || financePrice > maxOrderAmount) {
      return '';
    }

    var html = ``;
    if (financePrice > 22200) {
      var monthlyFinancePrice = 20000/finalMonth;
    } else {
      var depositAmount = financePrice * minDepositPercent;
      var monthlyFinancePrice = (financePrice - depositAmount)/finalMonth;
    }
    
    var monthlyFinancePrice = monthlyFinancePrice.toFixed(2);
    html = `Finance from £${monthlyFinancePrice} per month<br/>`;
    return html;
  }

  function checkTag(tag) {
    if (tag.includes('finance_0_')) {
      newTag = tag.replace('finance_0_', '');
      if(finalMonth == '') {
        finalMonth = newTag;
      }
      if(newTag > finalMonth) {
        finalMonth = newTag;
      }

    }
  }

  function buildSoldOutLabel() {
    // Build Sold out label
    var soldOutLabel = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
      soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
    }
    return soldOutLabel;
  }

  function buildSaleLabel() {
    // Build Sale label
    var saleLabel = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme);
    }
    return saleLabel;
  }

  function buildReview(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
      boostPFSThemeConfig.custom.show_product_review == true && Utils.getProductMetafield(data, 'reviews', 'rating') !== null) {
      var ratingObj = JSON.parse(Utils.getProductMetafield(data, 'reviews', 'rating'));
      var rating_decimal = 0;
      var decimal = parseFloat(ratingObj.value.rating);
      if (decimal >=0.3 && decimal <= 0.7) {
        rating_decimal = 0.5;
      } else if (decimal > 0.7) {
        rating_decimal = 1;
      }
      html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info.replace('{{ rating_value }}', ratingObj.value).replace('{{ rating_max }}', ratingObj.value.scale_max)}">
                <span aria-hidden="true" class="rating-star color-icon-${boostPFSConfig.custom.accent_icons}" style="--rating: ${Math.round(ratingObj.value.rating)}; --rating-max: ${ratingObj.value.scale_max}; --rating-decimal: ${rating_decimal};"></span>
              </div>
              <p class="rating-text caption">
                <span aria-hidden="true">${ratingObj.value} / ${ratingObj.value.scale_max}</span>
              </p>
              <p class="rating-count caption">
                <span aria-hidden="true">(${Utils.getProductMetafield(data, 'reviews', 'rating_count')})</span>
                <span class="visually-hidden">${Utils.getProductMetafield(data, 'reviews', 'rating_count')} ${boostPFSConfig.label.total_reviews}</span>
              </p>`;
    }
    return html;
  }
    
  function getAspectRatio(data) {
    var width = (data == null) ? '535' : data.width;
    var height = (data == null) ? '535' : data.height;

    return width / height;
  }

  function getRatioImage(data) {
    var ratio = 1;
    if (images && boostPFSThemeConfig.custom.media_size == 'portrait') {
      ratio = 0.8;
    } else if (images && boostPFSThemeConfig.custom.media_size == 'adapt') {
      ratio = getAspectRatio(data.images[0]);
    }
    if (ratio === 0 || ratio === null) {
      ratio = 1;
    }
    return ratio;
  }

  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || '';
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          var isSelected = ''
          if(paramSort == k) {
            isSelected = 'selected="selected"'
          }
          sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  ProductSorting.prototype.render = function () {
    jQ(Selector.topSorting).html(this.compileTemplate());

    if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
      jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
    }

    var labelSort = '';
    var paramSort = Globals.queryParams.sort || '';
    var sortingList = Utils.getSortingList();
    if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
      labelSort = sortingList[paramSort];
    } else {
      labelSort = Labels.sorting;
    }

    jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
  }

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function() {
    jQ(Selector.topSorting + ' .facet-filters__sort').change(function(e) {
      e.preventDefault();
      FilterApi.setParam('sort', jQ(this).val());
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
    });
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;
    /** End Swym integration **/
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

    // if (data.length < 3 && Utils.isCollectionPage()) {
    //   var bannerHtml = '<li class="grid__item"></li>';
    //   jQ(Selector.products).append(bannerHtml);
    // }

    
    
     if (data.length > 0 && data.length < 3 && Utils.isCollectionPage()) {
      const colId = Globals.queryParams.collection_scope;
      var bannerHtml = '';
      if (colId == "415917048043" || colId == "415916523755" || colId == "415821234411" || colId == "415916654827" || colId == "415916556523" || colId == "415888310507" || colId == "415888343275" || colId == "415888376043" || colId == "416051331307" || colId == "415820775659" || colId == "413451747563" || colId == "415888408811" || colId == "415888441579" || colId == "415888474347" || colId == "415917572331" || colId == "415820677355" || colId == "415821299947" || colId == "415820939499" || colId == "431036170475" || colId == "415917048043" || colId == "415888507115" || colId == "415820710123" || colId == "415916490987" || colId == "415821168875" || colId == "415820808427" || colId == "415820841195" || colId == "415820873963" || colId == "415820972267" || colId == "415821136107" || colId == "415821005035" || colId == "415821037803" || colId == "415821103339" || colId == "415820906731" || colId == "431036039403" || colId == "415821070571" || colId == "415916687595" || colId == "415916589291" || colId == "415821496555"){
        bannerHtml = '<li class="grid__item grid_big-item grid_big-item-3">' + 
          '<div class="image--area">' +
            '<img src="https://cdn.shopify.com/s/files/1/0662/2635/6459/files/finance-banner.jpg?v=1717097740"></img>' +
          '</div>' +
          '<div class="content--area">' +
            '<p class="h5"> 0% APR Finance available </p>' +
            '<p> 0% interest is available on all our new branded jewellery and watches and our pre-owned watches range.  </p>' +
            '<a href="https://charlesfish.co.uk/pages/finance-information-1"> Find out more </a>' +
          '</div>' +
        '</li>';
      } else if (Globals.queryParams.collection_scope == "415819464939" || Globals.queryParams.collection_scope == "433093148907") {
        bannerHtml = '<li class="grid__item grid_big-item grid_big-item-3">' + 
          '<div class="image--area">' +
            '<img src="https://cdn.shopify.com/s/files/1/0662/2635/6459/files/30.05.24_MODEL_SWAMI_0709-2.jpg?v=1721313569"></img>' +
          '</div>' +
          '<div class="content--area">' +
            '<p class="h5"> Independently valued and authenticated </p>' +
            '<p> Every item in this collection comes with an independent valuation and a certificate of authenticity from The Assay Office.   </p>' +        
          '</div>' +
        '</li>';        
      } else if (colId == "415820382443" || colId == "415820415211" || colId == "415820349675" || colId == "433093148907" || colId == "415819661547" || colId == "429683540203" || colId == "431165898987" || colId == "431125233899" || colId == "431166062827" || colId == "431166128363" || colId == "415820120299" || colId == "415819858155" || colId == "415819890923" || colId == "415820185835" || colId == "415819923691" || colId == "415819956459" || colId == "415820251371" || colId == "415820284139" || colId == "415819989227" || colId == "413451714795" || colId == "415819792619" || colId == "415819694315" || colId == "415819759851" || colId == "415820054763 " || colId == "415873007851" || colId == "415820021995" || colId == "415873106155" || colId == "415820447979"){
        var bannerHtml = '<li class="grid__item grid_big-item grid_big-item-3">' + 
        '<div class="image--area">' +
          '<img src="https://cdn.shopify.com/s/files/1/0662/2635/6459/files/30.05.24_MODEL_SWAMI_0709-2.jpg?v=1721313569"></img>' +
        '</div>' +
        '<div class="content--area">' +
          '<p > Fast shipping and easy returns </p>' +
          '<p> Order by 2 PM Monday to Friday and we will dispatch your items on the same day. Shipping is free on all orders over £49. </p>' +        
          '<p>Returns are free for UK customers requiring an exchange or refund. </p>' +
          '<a href="https://charlesfish.co.uk/pages/delivery-information">Find Out More</a>' +
        '</div>' +
      '</li>';
      }
      jQ(Selector.products).append(bannerHtml);
    }

    
     if (data.length == 0 && Utils.isCollectionPage()) {
      const colId = Globals.queryParams.collection_scope;
      var bannerHtmlSecond = '';
      if (colId == "415917048043" || colId == "415916523755" || colId == "415821234411" || colId == "415916654827" || colId == "415916556523" || colId == "415888310507" || colId == "415888343275" || colId == "415888376043" || colId == "416051331307" || colId == "415820775659" || colId == "413451747563" || colId == "415888408811" || colId == "415888441579" || colId == "415888474347" || colId == "415917572331" || colId == "415820677355" || colId == "415821299947" || colId == "415820939499" || colId == "431036170475" || colId == "415917048043" || colId == "415888507115" || colId == "415820710123" || colId == "415916490987" || colId == "415821168875" || colId == "415820808427" || colId == "415820841195" || colId == "415820873963" || colId == "415820972267" || colId == "415821136107" || colId == "415821005035" || colId == "415821037803" || colId == "415821103339" || colId == "415820906731" || colId == "431036039403" || colId == "415821070571" || colId == "415916687595" || colId == "415916589291" || colId == "415821496555"){
        bannerHtmlSecond = '<li class="grid__item grid_big-item grid_full-width-item">' + 
        '<div class="image--area">' +
          '<img src="https://cdn.shopify.com/s/files/1/0662/2635/6459/files/MAcro_3.jpg?v=1721309981"></img>' +
        '</div>' +
        '<div class="content--area">' +
          '<p class="h5">Cant find what you are looking for?</p>' +
          '<p> Let us know what you’re looking for and we will do all the hard work and find it for you.  </p>' +
          '<a href="https://charlesfish.co.uk/pages/source-a-watch">Source a watch</a>' +
        '</div>' +
      '</li>';
      } else if (Globals.queryParams.collection_scope == "415819464939" || Globals.queryParams.collection_scope == "433093148907") {
        bannerHtmlSecond = '<li class="grid__item grid_big-item grid_full-width-item">' + 
          '<div class="image--area">' +
            '<img src="https://cdn.shopify.com/s/files/1/0662/2635/6459/files/12.03.24_POJ_CHRISTINA_77164102-61-2.jpg?v=1721312804"></img>' +
          '</div>' +
          '<div class="content--area">' +        
            '<p class="h5"> Fast shipping and easy returns </p>' +  
            '<p> Order by 2 PM Monday to Friday and we will dispatch your items on the same day. Shipping is free on all orders over £49. </p>' +
            '<p>Returns are free for UK customers requiring an exchange or refund. </p>' +
            '<a href="https://charlesfish.co.uk/pages/delivery-information">Find Out More</a>' +
          '</div>' +
        '</li>';
      } else if (colId == "415820382443" || colId == "415820415211" || colId == "415820349675" || colId == "433093148907" || colId == "415819661547" || colId == "429683540203" || colId == "431165898987" || colId == "431125233899" || colId == "431166062827" || colId == "431166128363" || colId == "415820120299" || colId == "415819858155" || colId == "415819890923" || colId == "415820185835" || colId == "415819923691" || colId == "415819956459" || colId == "415820251371" || colId == "415820284139" || colId == "415819989227" || colId == "413451714795" || colId == "415819792619" || colId == "415819694315" || colId == "415819759851" || colId == "415820054763 " || colId == "415873007851" || colId == "415820021995" || colId == "415873106155" || colId == "415820447979"){
        bannerHtmlSecond = '<li class="grid__item grid_big-item grid_full-width-item">' + 
          '<div class="image--area">' +
            '<img src="https://cdn.shopify.com/s/files/1/0662/2635/6459/files/12.03.24_POJ_CHRISTINA_77164102-61-2.jpg?v=1721312804"></img>' +
          '</div>' +
          '<div class="content--area">' +
            '<p class="h5">Enjoy up to £100 off Your First Purchase</p>' +
            '<p> Sign up to our newsletter to get your welcome discount code straight away and start shopping. Plus get latest offers and early VIP access to our weekly new pieces!  </p>' +
            '<a href="https://latest.charlesfish.co.uk/p/7PU0-3PO/newslettersignup">Subscribe Now</a>' +
          '</div>' +
        '</li>';
      }
      jQ(Selector.products).append(bannerHtmlSecond);      
     }
  }

  // Keep the canonical tag, page title and address bar self-referential for the current
  // pagination state. Globals.queryParams.page is the source of truth here - it's the same
  // value the pagination widget itself uses to highlight the active page, so it's always
  // correct even though Boost's own history.pushState/replaceState (in boost-pfs-core.js)
  // can silently fail to advance the address bar on later pagination clicks. We hook the
  // boost-pfs-change-address-bar event since Boost fires it for every filter/sort/page change,
  // and force-correct window.location with replaceState whenever it disagrees with the real
  // current page, before syncing canonical/title to match.
  function updateCanonicalAndTitle() {
    var page = parseInt(Globals.queryParams.page) || 1;
    var base = window.location.origin + window.location.pathname;

    // Only correct the "page" param on the address bar - preserve any other
    // params (filters, sort, search term, etc.) already in the URL.
    var params = new URLSearchParams(window.location.search);
    var expectedPageParam = page > 1 ? String(page) : null;
    if (params.get('page') !== expectedPageParam) {
      if (expectedPageParam === null) {
        params.delete('page');
      } else {
        params.set('page', expectedPageParam);
      }
      var query = params.toString();
      history.replaceState(history.state, '', base + (query ? '?' + query : ''));
    }

    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', page > 1 ? base + '?page=' + page : base);
    }
    var baseTitle = document.title.replace(/\s+–\s+Page\s+\d+\s*$/, '');
    document.title = page > 1 ? baseTitle + ' – Page ' + page : baseTitle;
  }
  jQ(window).on('boost-pfs-change-address-bar', updateCanonicalAndTitle);

  // Build Additional Elements
  Filter.prototype.afterRender = function(data, eventType) {
    if (!data) data = this.data;
    jQ('.boost-pfs-filter-total-product').html(data.total_product + ' products');
    renderRefineByHtml(eventType);

    jQ('#boost-pfs-filter-tree').css('visibility', 'visible');
    if (jQ('#boost-pfs-filter-tree-pf-p-price').parents('.boost-pfs-filter-options-wrapper').find('.boost-pfs-filter-option-title-text').html()) {
      var newText = jQ('#boost-pfs-filter-tree-pf-p-price').parents('.boost-pfs-filter-options-wrapper').find('.boost-pfs-filter-option-title-text').html().replace('(£)','');
      // jQ('#boost-pfs-filter-tree-pf-p-price').parents('.boost-pfs-filter-options-wrapper').find('.boost-pfs-filter-option-title-text').html(newText)
      jQ('.boost-pfs-filter-button[aria-controls="boost-pfs-filter-tree-pf-p-price"] .boost-pfs-filter-option-title-text').html(newText)
    }

    updateCanonicalAndTitle();
  };

  /*Boost 170938*/
function renderRefineByHtml(eventType) {
  if (!Utils.isMobile()) {
    let refine = Settings.label.refine || 'Refine By';
    let refineByHtml = `<div class="boost-pfs-filter-refine-by">
                            <div class="boost-pfs-filter-option-title">
                                <div class="boost-pfs-filter-option-title-heading" role="heading" aria-level="2"><span>${refine}</span></div>
                                <button aria-label="Clear all filters" class="boost-pfs-filter-button boost-pfs-filter-clear-all">Clear All</button>
                            </div>
                            <div class="boost-pfs-filter-refine-by-items"></div>
                        </div>`;
    if (jQ('.boost-pfs-filter-refine-by-wrapper').find('.boost-pfs-filter-refine-by').length == 0 ) {
      jQ('.boost-pfs-filter-refine-by-wrapper').html(refineByHtml); 
    }
  }
}
/*End 170938*/
  /************************** END BUILD TOOLBAR **************************/
  FilterOptionItemList.prototype.compileTemplate = function () {
  var label = this.label;
  this.label = label.replaceAll("-", " ");
  
  return this.getTemplate()
			.replace(/{{class.filterOptionItem}}/g, Class.filterOptionItem)
			.replace(/{{class.filterOptionLabel}}/g, Class.filterOptionLabel)
			.replace(/{{class.button}}/g, Class.button)
			.replace(/{{disabled}}/g, this.isDisabled() ? 'disabled' : '')
			.replace(/{{label}}/g, Utils.stripHtml(this.label))
			.replace(/{{href}}/g, this.href)
			.replace(/{{countLabel}}/g, Utils.stripHtml(this.countLabel));
}

FilterClearButton.prototype.compileTemplate = function (){
    this.buildLabel();
  var clearLabel = this.filterValueLabel;
  this.filterValueLabel = clearLabel.replaceAll("-", " ");
  return this.getTemplate()
			.replace(/{{label.clear}}/g, Labels.clear)
			.replace(/{{class.button}}/g, Class.button)
			.replace(/{{class.clearButton}}/g, Class.clearButton)
			.replace(/{{class.clearAllButton}}/g, Class.clearAllButton)
			.replace(/{{adaLabel}}/g, Utils.stripHtml(this.adaLabel))
			.replace(/{{label}}/g, Utils.stripHtml(this.label))
			.replace(/{{filterOptionLabel}}/g, this.filterOptionLabel)
			.replace(/{{filterValueLabel}}/g, this.filterValueLabel);
}

  FilterApi.beforeCall = function(eventType, eventInfo) {
    if (Globals.queryParams.h_options = []) {
      Globals.queryParams.h_options.push("collection-and-search");
    }
  }
})();
